import React, { useState } from 'react'
import { useTranslate } from 'react-polyglot'

import { Text, ButtonGroup, Button, Checkbox } from 'components'

import './memberSearch.scss'

export default ({ members, onAdd, onClose }) => {
	const t = useTranslate()
	const [filterText, setFilterText] = useState('')
	const [checkboxes, setCheckboxes] = useState([])

	const setCheckbox = (id, checked) => {
		const newCheckboxes = checked
			? [...checkboxes, id]
			: checkboxes.filter(c => c !== id)

		setCheckboxes(newCheckboxes)
	}

	const filteredMembers = members
		? members.filter(m =>
				`${m.firstName} ${m.lastName}`
					.toLowerCase()
					.includes(filterText.toLowerCase())
		  )
		: []

	return (
		<>
			<div className="c-member-search">
				<div className="c-member-search__input-wrap">
					<input
						autoFocus
						type="search"
						className="c-member-search__input"
						placeholder={t('search_for_team_members')}
						onChange={e => {
							setFilterText(e.target.value)
						}}
						value={filterText}
					/>
				</div>
				<div className="c-member-search__list">
					{filteredMembers.map(m => (
						<div className="c-member-search__item" key={m.id}>
							<Checkbox
								value="default"
								name="member"
								label={`${m.firstName} ${m.lastName}`}
								checked={
									!!(checkboxes && checkboxes.includes(m.id))
								}
								onChange={e => {
									setCheckbox(m.id, e.target.checked)
								}}
							/>
						</div>
					))}
					{filteredMembers.length === 0 && (
						<Text size="small" color="light">
							{t('nobody_found')}
						</Text>
					)}
				</div>
				<div className="c-member-search__actions">
					<ButtonGroup orientation="horizontal">
						<Button
							onClick={() => {
								onAdd(checkboxes, onClose)
							}}
							text={t('add')}
							size="small"
							layout="primary"
						/>
						<Button
							onClick={() => {
								onClose()
							}}
							text={t('cancel')}
						/>
					</ButtonGroup>
				</div>
			</div>
		</>
	)
}
